/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs */

const en__field__enum_teachingsubjects_subject_politics_economics25 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politics & Economics`)
};

const de__field__enum_teachingsubjects_subject_politics_economics25 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politik & Wirtschaft`)
};

/**
* | output |
* | --- |
* | "Politics & Economics" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_politics_economics25 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Politics_Economics25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_politics_economics25(inputs)
	return de__field__enum_teachingsubjects_subject_politics_economics25(inputs)
});
export { _field__enum_teachingsubjects_subject_politics_economics25 as "_field__enum_teachingSubjects_SUBJECT_POLITICS_ECONOMICS" }